import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PipelineFilterConstants } from '../constant/pipelinefilterConstants';

/**
 * Bridges the pipeline filter modal (PipelineFilterComponent, opened by
 * ProjectDetailsViewComponent) with the pipeline candidate listing
 * (ProjectPipelineComponent). The two are siblings rendered in different
 * parts of the component tree (the modal is opened dynamically via
 * NgbModal, and the listing lives inside a router-outlet), so there's no
 * direct template binding possible between them — this service is the
 * connective tissue, same pattern as FilterStoreService for HireFilterComponent.
 *
 * Two separate pieces of state are kept:
 * - filterPayload$: the *applied* filter (pushed only when Apply is
 *   clicked) - this is what the listing actually fetches with.
 * - filterState (get/setState): the modal's raw UI selections (chips,
 *   checkboxes, etc.), saved on every change - lets the modal restore
 *   exactly what was selected the next time it's reopened, whether or not
 *   Apply was ever clicked.
 */
@Injectable({ providedIn: 'root' })
export class PipelineFilterStoreService {
  constructor(private router: Router) {}

  private filterPayloadSource = new BehaviorSubject<any>({});
  filterPayload$ = this.filterPayloadSource.asObservable();

  private filterState: any = null;

  setFilter(payload: any): void {
    this.filterPayloadSource.next(payload || {});
  }

  getFilter(): any {
    return this.filterPayloadSource.getValue();
  }

  setState(state: any): void {
    this.filterState = state;
  }

  getState(): any {
    return this.filterState;
  }

  clear(): void {
    this.filterPayloadSource.next({});
    this.filterState = null;
  }

   shouldShowPipelineFilter(filterName: string): boolean {
      const url = this.router.url;

      if (url.includes('/my-candidates')) {
        return PipelineFilterConstants.MY_CANDIDATES_FILTER_MODAL.has(filterName);
      }

      if (url.includes('/pipeline')) {
        return PipelineFilterConstants.PIPELINE_FILTER_MODAL.has(filterName);
      }

      return false;
    }
}
